import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Loadable } from '../helpers/loadable';

@Component({
  selector: 'are-you-sure',
  styleUrls: ['./are-you-sure.component.scss'],
  templateUrl: './are-you-sure.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AreYouSureComponent implements OnInit {
  @Input()
  mainText: string;

  @Input()
  submitText: string;

  @Input()
  title: string;

  @Input()
  width: string;

  @Input() load: Loadable<any> | Loadable<any>[];

  @Input() submitting: boolean;

  @Input()
  submitConfirmationMessage: string;

  @Input()
  submitConfirmationText: string;

  @Input()
  showAlternateSubmitLogic: boolean = false;

  @Input()
  alternateSubmitLogicText: string = '';

  @Output()
  close = new EventEmitter<void>();

  @Output()
  submitted = new EventEmitter<void>();

  @Output()
  alternateSubmitLogicValueChange = new EventEmitter<boolean>();

  confirmationText: string = '';

  confirmed: boolean = true;

  alternateSubmitLogicValue: boolean = true;

  changeAlternateSubmitLogicValue = (event: boolean) => {
    this.alternateSubmitLogicValue = event;
  };

  checkConfirmation(text: string) {
    this.confirmationText = text;
    this.confirmed = this.submitConfirmationText === text;
  }

  ngOnInit(): void {
    this.confirmed = !this.submitConfirmationText;
  }
}
